import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import ListagemFaturas from '@/views/faturas/ListagemFaturas.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import DetalhePedido from '@/views/escritorios/DetalhePedido.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import DetalheFatura from '@/views/faturas/DetalheFatura.vue'
import { mapState } from 'vuex'

export default {
  name: 'faturas',
  props: {
    idEscritorio: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    cabecalho,
    pagination,
    ListagemFaturas,
    DetalhePedido,
    DetalheFatura,
    spinnerProcessando
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    desabilitarCampos () {
      return this.flagsDeControle.carregandoDados.status
    },
    tabelaFaturasSemRegistros () {
      return this.listaFaturas.length === 0
    },
    apresentarDetalheFatura () {
      return !util.valorVazio(this.detalheFatura)
    }
  },
  data: () => {
    return {
      listaFaturas: [],
      detalheFatura: [],
      itensDaFatura: [],
      cupomSelecionado: [],
      fields: [
        { key: 'descricao', sortable: false, label: 'Descricao' },
        { key: 'data_emissao', sortable: false, label: 'Emissão' },
        { key: 'data_vencimento', sortable: false, label: 'Vencimento' },
        { key: 'valor_total', sortable: false, label: 'Valor' },
        { key: 'status', sortable: false, label: 'Status' }
      ],
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      mostrarDetalhe: false,
      carregandoDetalhe: false
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.buscarRegistros()
  },

  methods: {
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    async obterListaFaturas () {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'filtros': {
            'f_tipo': 2,
            'id_tenant': this.idEscritorio
          },
          'ordenacao': this.componenteOrdenacao
        }
        const resposta = await this.axios.post(`/escritorios/escritorio/faturas`, parametrosRequisicao)
        if (resposta.data.retorno.dados.length > 0) {
          this.listaFaturas = resposta.data.retorno.dados
          this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
          this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    buscarRegistros () {
      this.componentePaginacao.pagina = 1
      this.obterListaFaturas()
    },
    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaFaturas()
    },
    async obterDetalhamentoFatura (faturaId) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      try {
        const resposta = await this.axios.get(`/escritorios/faturas/${faturaId}/escritorio/${this.$route.params.id}`)
        if (resposta.data.retorno.dados.detalhes_fatura) {
          this.detalheFatura = resposta.data.retorno.dados.detalhes_fatura
          this.itensDaFatura = resposta.data.retorno.dados.itens
          this.cupomSelecionado = resposta.data.retorno.dados.cupom
        }
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },
    obterDescricaoFatura (fatura) {
      if (!util.valorVazio(fatura.descricao)) {
        return fatura.descricao
      }
      return 'Mensalidade'
    },
    formatarValorMonetario (valor) {
      return util.formatarValorMonetarioComCifrao(valor)
    },
    async selecionarFatura (fatura) {
      this.carregandoDetalhe = true
      await this.obterDetalhamentoFatura(fatura.id)
      this.mostrarDetalhe = true
      this.carregandoDetalhe = false
    },
    async voltarParaListagem () {
      await this.buscarRegistros()
      this.mostrarDetalhe = false
      this.carregandoDetalhe = false
    },
    async obterNotaFiscal (idFatura) {
      return this.axios.get(`/fatura/${idFatura}/download/nota_fiscal/pdf/configuracao/visualizar`)
    },
    async fazerDownloadNotaFiscal (idFatura) {
      return this.axios.get(`/fatura/${idFatura}/download/nota_fiscal/xml/configuracao/baixar`, {
        responseType: 'blob'
      })
    }
  }
}
